import { render } from "./AppSideMenu.vue?vue&type=template&id=9f7c65e6&scoped=true"
import script from "./AppSideMenu.vue?vue&type=script&lang=js"
export * from "./AppSideMenu.vue?vue&type=script&lang=js"

import "./AppSideMenu.vue?vue&type=style&index=0&id=9f7c65e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f7c65e6"]])

export default __exports__